export default "__VITE_ASSET__1f6b518a__"